export const isDeveloperMode = import.meta.env.VITE_DEV_MODE === 'true';

export const devModeData = {
  account: {
    fullName: 'John Developer',
    email: `dev-${Date.now()}@test.com`,
    password: 'TestPassword123!',
    phone: '+1234567890'
  },
  business: {
    businessName: 'Test Business Inc',
    website: 'https://testbusiness.com',
    industry: 'Technology',
    monthlyBudget: '1000-5000',
    targetAudience: 'B2B SaaS companies looking for growth',
    currentChallenges: 'Need to scale marketing efforts efficiently',
    businessGoals: 'Generate more qualified leads with consistent content and follow-up'
  },
  serviceType: 'content-engine',
  services: ['content-engine-monthly'],
  integrations: {
    google_analytics: true,
    google_ads: false,
    facebook_ads: false,
    instagram: false,
    linkedin: false
  }
};

export function logDevMode() {
  if (isDeveloperMode) {
    console.log('%c🔧 DEVELOPER MODE ENABLED', 'background: #222; color: #bada55; font-size: 16px; padding: 10px;');
    console.log('All forms will be pre-populated with test data');
    console.log('Dev data:', devModeData);
  }
}
